<template>
  <div class="header-top" :class="{'noBack':!showBack,'haveTab':haveTab}">
    <div @click="goTo" class="header-back" v-if="showBack">
      <svg-icon class="header-svg" icon-class="left-arrow" />
    </div>
    <span v-if="headerText">{{headerText}}</span>
    <span v-else>{{header}}</span>
  </div>
</template>

<script>
export default {
  props: {
    showBack: { type: Boolean },
    haveTab: { type: Boolean },
    headerText: { type: String }, //头部标题
    routerInfo:{type:String}
  },
  data() {
    return {
      header: "",
      router:this.$route
    };
  },
  mounted () {
    let arr=[];
    this.router.matched.map(item=>{
      if (item.meta.title) {
        arr.push(item.meta.title)
      }
    })
    this.header=arr.join(' / ')
  },
  methods:{
    goTo(){
      if(this.routerInfo){
        this.$router.push({ path: this.routerInfo });
      }else{
        this.$router.go(-1)
      }
      
    }
  }
};
</script>

<style lang="scss" scoped>
.header-top {
  display: flex;
  align-items: center;
  box-sizing: border-box;

  padding-left: 20px;
  height: 42px;
  width: 100%;

  line-height: 42px;
  font-size: 14px;

  color: #666;
  background-color: #fff;
  box-shadow: 0 2px 3px rgba(0,0,0,.2);
  .header-back {
    display: flex;
    align-items: center;
    justify-content: center;

    margin: 0 23px 0 0;
    height: 26px;
    width: 26px;
    cursor: pointer;
    border-radius: 4px;

    &:hover {
      background-color: #f2f2f2;
    }

    .header-svg {
      width: 14px;
      height: 14px;
      color: $--color-primary;
    }
  }
}
.noBack {
  padding-left: 20px;
}
.haveTab {
  padding-top:5px;
  line-height: 88px;
  height: 32px;
}
</style>